export function normalizarAcentos(texto) {
  if (!texto || typeof texto !== 'string') {
    return '';
  }
  
  return texto
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}
